import CheckSinglePosition from './src/main';

/* istanbul ignore next */
CheckSinglePosition.install = function(Vue) {
  Vue.component(CheckSinglePosition.name, CheckSinglePosition);
};

export default CheckSinglePosition;
